











import {
  Component,
  Vue,
  Prop,
  Watch,
} from 'vue-property-decorator';
import EventBus from '@/event-bus';
import Icon from '@/components/common/icon.vue';

@Component({
  components: {
    Icon,
  },
})
export default class PopoverComponent extends Vue {
  @Prop()
  isShown!: boolean;

  @Prop()
  hideTitle!: boolean;

  @Prop()
  switchStyles!: boolean;

  displayDelayed = false;

  showDelayed = false;

  parent: any;

  offsetX = 0;

  offsetY = 0;

  diffX = 0;

  @Watch('isShown')
  onIsShownChanged(newVal: boolean) {
    if (newVal) {
      EventBus.$emit('popover:closeAllExcept', this.$el).$emit('popover:open', this.$el);
    } else {
      EventBus.$emit('popover:close', this.$el);
    }
  }

  mounted() {
    this.parent = this.$el.parentElement;
    const body = document.querySelector('body');
    if (body) {
      body.appendChild(this.$el);
    }

    EventBus.$on('popover:open', (payload: any) => {
      if (this.$el === payload) {
        this.getPosition();
        this.displayDelayed = !this.displayDelayed;
        setTimeout(() => {
          this.showDelayed = !this.showDelayed;
          document.body.addEventListener('click', this.clickOutsideEvent);
          this.calcDiff();
        }, 150);
      }
    });

    EventBus.$on('resize', () => {
      this.getPosition();
      this.calcDiff();
    });

    EventBus.$on('popover:close', (payload: any) => {
      if (this.$el === payload) {
        this.showDelayed = false;
        setTimeout(() => {
          this.displayDelayed = false;
          this.$emit('closed');
        }, 150);
        document.body.removeEventListener('click', this.clickOutsideEvent);
      }
    });

    EventBus.$on('popover:closeAllExcept', (payload: any) => {
      if (this.$el !== payload) {
        this.showDelayed = false;
        setTimeout(() => {
          this.displayDelayed = false;
          this.$emit('closed');
        }, 150);
        document.body.removeEventListener('click', this.clickOutsideEvent);
      }
    });

    EventBus.$on('popover:closeAll', () => {
      this.showDelayed = false;
      setTimeout(() => {
        this.displayDelayed = false;
        this.$emit('closed');
      }, 150);
      document.body.removeEventListener('click', this.clickOutsideEvent);
    });
  }

  calcDiff() {
    if (this.$refs.popover) {
      const diff = window.innerWidth - (((this.$refs.popover as HTMLHtmlElement).clientWidth / 2) + this.offsetX);
      if (diff < 0) {
        this.diffX = Math.abs(diff) + 20;
      } else if (diff < 20) {
        this.diffX = 20;
      } else {
        this.diffX = 0;
      }
    }
  }

  beforeDestroy() {
    document.body.removeEventListener('click', this.clickOutsideEvent);
  }

  clickOutsideEvent(event: Event) {
    if (this.displayDelayed && !(this.$refs.popover === event.target || (this.$refs.popover as HTMLElement).contains(event.target as HTMLElement))) {
      this.close();
    }
  }

  close() {
    if (this.displayDelayed) {
      EventBus.$emit('popover:close', this.$el);
    }
  }

  getPosition() {
    this.offsetX = this.parent.getBoundingClientRect().left + this.parent.clientWidth / 2;
    this.offsetY = this.parent.getBoundingClientRect().top + this.parent.getBoundingClientRect().height + 4 + document.documentElement.scrollTop;
  }
}
